import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IAppState } from "../../../types/stores";
import withModal from "../withModal";
import MaterialModal from "../MaterialModal";
import { hideModal } from "../../../actions/actionCreators";
import { UserDeleteActionData } from "../../../types/stores/adminDesigner";
import UserDelete from "../../admin/users/UserDelete";
import UserDetails from "../../admin/users/UserDetails";
import { SetReassignItemsToUser } from "../../../actions/reassignedItemsToActions";
import { requestDeleteUser, requestReassignUserItemsThenDelete } from "../../../actions/userActions";
import h from "../../../helpers";
import { requestFlows } from "../../../actions/flowActions";

interface IUserDeleteActionModal {
    isOpen: boolean;
    modalProps: {
        userId: number;
    };
}

const UserDeleteModal: React.FC<IUserDeleteActionModal> = ({ modalProps, isOpen }: IUserDeleteActionModal) => {
    const dispatch = useDispatch();

    const [reassignFolderName, setReassignFolderName] = useState("");
    const [showPrimaryButton, setShowPrimaryButton] = useState(true);
    const [reassignMenu, setReassignMenu] = useState(false);
    const currentReassignedUser = useSelector((state: IAppState) => state.reassignedItemsTo.reassiendUserId || 0);

    useEffect(() => {
        if (modalProps.userId) {
            dispatch(requestFlows());
        }
    }, [dispatch, modalProps.userId]);

    const hide = () => dispatch(hideModal("USER_DELETE_REASSIGN_ITEMS"));

    const prepareHide = () => {
        dispatch(SetReassignItemsToUser(0));
        hide();
    };

    const handleDeleteClick = () => {
        if (reassignMenu) {
            if (currentReassignedUser == 0) {
                h.error("User selection is required.");
            } else {
                dispatch(
                    requestReassignUserItemsThenDelete(modalProps.userId, currentReassignedUser, reassignFolderName)
                );
            }
        } else {
            dispatch(requestDeleteUser(modalProps.userId));
        }
        hide();
    };

    const handleAction = (data: UserDeleteActionData) => {
        setShowPrimaryButton(data.IsShowPrimaryButton);
        setReassignMenu(data.IsReassignedTo);
        setReassignFolderName(data.ReassignedFolderName);
    };

    return (
        <MaterialModal
            id="variable-admin-modal"
            isOpen={isOpen}
            onClose={prepareHide}
            onPrimaryButtonRequest={handleDeleteClick}
            title="Delete this user?"
            showPrimaryButton={showPrimaryButton}
            primaryButtonText="Delete"
            cancelButtonText="Close"
        >
            <UserDelete userId={modalProps.userId} onChangeImportAction={handleAction} />
            <UserDetails userId={modalProps.userId} />
        </MaterialModal>
    );
};

export default withModal(UserDeleteModal, "USER_DELETE_REASSIGN_ITEMS");
